import * as shp from "shpjs/dist/shp";
import { kml, gpx } from "@tmcw/togeojson";
import JSZip from "jszip";

const fileToArrayBuffer = require("file-to-array-buffer");

export async function ReadFile(file) {
  const ext = file.name.split(".").pop().toLowerCase();

  switch (ext) {
    case "zip":
      return await ReadShapefile(file);
      break;

    case "kml":
      return await ReadKMLFile(file);

    case "dxf":
      return ReadDXFFile(file);

    case "gpx":
      return await ReadGPXFile(file);

    case "json":
      return await ReadGeoJSON(file);

    default:
      break;
  }
}

export async function ReadShapefile(file) {
  let hasPrjFile = false;
  let prj = "";
  var jsZip = new JSZip();
  await jsZip.loadAsync(file).then(async function (zip) {
    for (var filename in zip.files) {
      let ext = filename.split(".")[filename.split(".").length - 1];

      if (ext.toLowerCase() == "prj") {
        hasPrjFile = true;
        await zip.files[filename].async("string").then(function (fileData) {
          prj = fileData;
        });
      }
    }
  });

  return await fileToArrayBuffer(file).then(async (data) => {
    return await shp(data).then(function (geojson) {
      geojson.hasPrjFile = hasPrjFile;
      geojson.prj = prj;
      return geojson;
    });
  });
}

export async function ReadGPXFile(file) {
  const _gpx = await FileToString(file);

  return gpx(new DOMParser().parseFromString(_gpx, "text/xml"));
}

export async function ReadDXFFile(file) {
  const _dxf = await FileToString(file);

  let geojson = window["GeoConvert"].dxf2Geojson({
    dxf: _dxf,
  });

  geojson.features.forEach((el) => {
    if (el.geometry.type == "LineString") {
      el.geometry.coordinates = [[el.geometry.coordinates]];
      el.geometry.type = "MultiPolygon";
    }
  });

  return geojson;
}

async function FileToString(file) {
  return new Promise((resolve, reject) => {
    var fr = new FileReader();
    fr.onload = () => {
      resolve(fr.result);
    };
    fr.readAsText(file);
  });
}

export async function ReadKMLFile(file) {
  const _kml = await FileToString(file);

  return kml(new DOMParser().parseFromString(_kml, "text/xml"));
}

export async function ReadGeoJSON(file) {
  const _geojson = await FileToString(file);

  return JSON.parse(_geojson);
}

export function ReadCSVFile(file) {}
